import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import InstituteLayout from "../layout/InstituteLayout";
import MyBook from "../pages/myBook/MyBook";
import Home from "../pages/home/Home";
import Login from "../pages/authentication/login/Login";
import ForgotPassoword from "../pages/authentication/ForgotPassoword";
import OtherBooks from "../pages/otherBooks/OtherBooks";
import BookDetails from "../pages/bookDetails/BookDetails";
import ReadBook from "../pages/readBook/ReadBook";
import ExploreMore from "../pages/exploreMore/ExploreMore";
import Quiz from "../pages/Quiz/Quiz";
import Account from "../pages/Account/Account";
import Otp from "../pages/authentication/Otp";
import NewPassword from "../pages/authentication/NewPassword";
import { AuthContext } from "../context";
import InstituteLogin from "../pages/authentication/login/InstituteLogin";
import FreeBook from "../pages/freebook/Freebook";
import Newspapers from "../pages/newspapers/Newspapers";
import Videos from "../pages/videos/Videos";
import Highlight from "../pages/highlight/Highlight";
import HighlightDetails from "../pages/highlight/HighlightDetails";
import ImpressiveRead from "../pages/readBook/ImpressiveRead";

const PageRouter = () => {
  const { user, forgetPassStatus } = useContext(AuthContext);
  const location = useLocation();

  const navigate = useNavigate();
  useEffect(() => {
    const userLoggedInStatus = JSON.parse(
      localStorage?.getItem("user_details_json")
    );

    const publicRoutes = ["/", "/:instituteId"]; // List of routes that are public

    const isPublicRoute = publicRoutes.some((route) => {
      const regex = new RegExp(`^${route.replace(":instituteId", "[^/]+")}$`);
      return regex.test(location.pathname);
    });

    if (!user || userLoggedInStatus === null) {
      if (!forgetPassStatus && !isPublicRoute) {
        navigate("/");
      }
    }
  }, [navigate, user, forgetPassStatus]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/:instituteId" element={<InstituteLogin />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgotpassword" element={<ForgotPassoword />} />
      <Route path="/otp" element={<Otp />} />
      <Route path="/newpassword" element={<NewPassword />} />
      {user && (
        <>
          <Route path="/readbook/:id" element={<ReadBook />} />
          <Route path="/impresiveread/:id" element={<ImpressiveRead />} />
        </>
      )}
      <Route element={<InstituteLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/mybook" element={<MyBook />} />
        <Route path="/books/:id" element={<OtherBooks />} />
        <Route path="/exploremore" element={<ExploreMore />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/account" element={<Account />} />
        <Route path="/freebooks" element={<FreeBook />} />
        <Route path="/newspapers" element={<Newspapers />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/highlight" element={<Highlight />} />
        <Route path="/highlight/:id" element={<HighlightDetails />} />

        <Route path="/aboutbook/:id" element={<BookDetails />} />
      </Route>
    </Routes>
  );
};

export default PageRouter;
